import { useAppContext } from 'src/AppContext'

/**
 * Contains React hooks for the MobX store.
 */

export const useAnalyticsStore = () => {
  const { analyticsStore } = useAppContext().store
  return analyticsStore
}

export const useAppConfigStore = () => {
  const { appConfigStore } = useAppContext().store
  return appConfigStore
}

export const useIntegrationStore = () => {
  const { integrationStore } = useAppContext().store
  return integrationStore
}

export const useMarketplaceStore = () => {
  const { marketplaceStore } = useAppContext().store
  return marketplaceStore
}

export const usePresentationStore = () => {
  const { presentationStore } = useAppContext().store
  return presentationStore
}

export const useAssetsStore = () => {
  const { assetStore } = useAppContext().store
  return assetStore
}

export const useSettingsStore = () => {
  const { settingsStore } = useAppContext().store
  return settingsStore
}

export const useTeamsStore = () => {
  const { teamsStore } = useAppContext().store
  return teamsStore
}

export const useUIStore = () => {
  const { uiStore } = useAppContext().store
  return uiStore
}

export const useUserStore = () => {
  const { userStore } = useAppContext().store
  return userStore
}

export const useAutomationStore = () => {
  const { automationStore } = useAppContext().store
  return automationStore
}

export const useThemeStore = () => {
  const { themeStore } = useAppContext().store
  return themeStore
}

export const useFontStore = () => {
  const { fontStore } = useAppContext().store
  return fontStore
}
